import React, { useEffect } from "react";
import ExperientialComponent from "../components/molecules/experiential/ExperientialComponent";
import { TutorProvider } from "../context/AiTutorContext";
import { PracticeProvider } from "../context/PracticeContext";
import { LearnProvider } from "../context/LearnContext";
import { WallProvider } from "../context/WallContext";
import { removeCookie } from "../utils/TutorConstants";
export let loader = async () => {
  return { type: "experiential" };
};

const Experiential = () => {
  useEffect(() => {
    removeCookie("taskProgressId");
  }, []);

  return (
    <TutorProvider>
      <PracticeProvider>
        <WallProvider>
          <ExperientialComponent />
        </WallProvider>
      </PracticeProvider>
    </TutorProvider>
  );
};

export default Experiential;
